import { TAMBAH_INVENTORY_KASIR } from "../../constants/admin/masterdata/constants";

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const tambahInventoryKasirReducer = (state = initialState, action) => {
  switch (action.type) {
    case TAMBAH_INVENTORY_KASIR.LOADING_TAMBAH_INVENTORY_KASIR:
      return {
        ...state,
        loading: action.load,
      };

    case TAMBAH_INVENTORY_KASIR.TAMBAH_INVENTORY_KASIR_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        data: action.data,
        error: null,
      };

    case TAMBAH_INVENTORY_KASIR.TAMBAH_INVENTORY_KASIR_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case TAMBAH_INVENTORY_KASIR.TAMBAH_INVENTORY_KASIR_RESET:
      return {
        ...state,
        success: false,
        error: null,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

export default tambahInventoryKasirReducer;
